import dictionary_json from "@/assets/static/dictionary.json";

export type Dictionary = typeof dictionary;
export type DictionaryKeys = keyof Dictionary;

const dictionary = { ...dictionary_json } as const;

export default dictionary;
